import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {EvkCreateServiceBase, EvkHttpService, MessageCrudService} from '@evomatik/evk-common';
import {DiligenciaTareaModel} from "../../../../../../../diligencia/models/diligencia-tarea.model";
import {CatalogosService} from "../../../../../../../expediente/services/catalogos.service";

@Injectable({
    providedIn: 'root'
})
export class EnAutorizacionDiligenciaCreateService extends EvkCreateServiceBase<any> {

    public doneSave;

    constructor(
        public http: EvkHttpService,
        public messageCrudService: MessageCrudService,
        public catalogoService: CatalogosService
    ) {
        super(http);
    }

    get api(): string {
        return '/seaged-diligencias-service/diligencia/solicitar';
    }

    evkOnBeforeSave(data: any): Observable<any> {
        return new Observable(
            (observer) => {
                if (data.usuarioAsignado != null) {
                    const usuario = data.usuarioDestino.value;
                    if (data['adicionalFormData']) {
                        this.loadValuesForDiligencia(data, usuario).subscribe(
                            data2 => {
                                data = data2;
                                data2.adicionalFormData['idDiligencia'] = data.id;
                                this.catalogoService.updateAdicionalData({
                                    id: '',
                                    data: data2.adicionalFormData
                                }).subscribe(data3 => {

                                });
                                observer.next(data);
                            }
                        );
                    } else {
                        observer.next(data);
                    }
                }
                observer.next(data);
            }
        );
    }

    evkOnDoneSave(response: any): void {
        this.doneSave();
    }

    evkOnErrorSave(error: any): void {
        this.messageCrudService.snackbarMessage(error);
    }

    loadValuesForDiligencia(diligencia: DiligenciaTareaModel, usuario): Observable<any> {
        return new Observable<any>(
            reponsee => {
                this.catalogoService.getUsuarioOrganizacionByUsername(usuario).subscribe(
                    usuarioResponse => {
                        if (usuarioResponse.nombreCompleto) {
                            diligencia.adicionalFormData['nombreEncargadoInvestigacion'] = usuarioResponse.nombreCompleto;
                        }
                        if (usuarioResponse.cargo) {
                            diligencia.adicionalFormData['cargoEncargadoInvestigacion'] = usuarioResponse.cargo;
                        }
                        if (usuarioResponse.numeroPlaca) {
                            diligencia.adicionalFormData['numeroEmpleadoEncargado'] = usuarioResponse.numeroPlaca;
                        }
                        if (usuarioResponse.numeroPatrulla) {
                            diligencia.adicionalFormData['unidadEncargadoInvestigacion'] = usuarioResponse.numeroPatrulla;
                        }
                        reponsee.next(diligencia);
                    }
                );
            }
        );
    }
}
